exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.saveButtons {\n  -ms-flex-item-align: center;\n      align-self: center;\n}\n.el-card {\n  margin-top: 5px;\n}\ndiv.el-transfer-panel {\n  width: 350px;\n}\n.register > .el-input__inner {\n  width: 220px;\n}\n.el-input.iban {\n  width: 300px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6ff70274","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/RegisterForm.vue
// module id = ycBF
// module chunks = 1